export default {
	baseURL: process.env.VUE_APP_BACKEND_HOST,
	apartmentType: process.env.VUE_APP_APARTMENT_TYPE,
	debug: false,
	// analytics: {
	// 	gtmId: "GTM-TCQB4RV"
	// }
}
